import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchPPRSearchReport({ state }, { expPremierProfileReportjsonData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.bcrApiPath.experianpprcompanysearch
        }`,
        expPremierProfileReportjsonData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchPremierProfileReport(
    { state },
    { expPremierProfileReportjsonData } = {}
  ) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.bcrApiPath.experianpprreport}`,
        expPremierProfileReportjsonData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
